'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _DocumentModeCanvasClusterDebugger = require('./DocumentModeCanvasClusterDebugger');

var _DocumentModeCanvasClusterDebugger2 = _interopRequireDefault(_DocumentModeCanvasClusterDebugger);

var _DocumentModeCanvasReadingLineDebugger = require('./DocumentModeCanvasReadingLineDebugger');

var _DocumentModeCanvasReadingLineDebugger2 = _interopRequireDefault(_DocumentModeCanvasReadingLineDebugger);

require('./DocumentModeCanvasDebugger.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        documentModeDebugEnabled: state.getIn(['debug', 'enabled']) && state.getIn(['debug', 'documentMode', 'enabled']),
        documentModeData: state.getIn(['debug', 'documentMode', 'data'])
    };
};

var DocumentModeCanvasDebugger = function DocumentModeCanvasDebugger(props) {
    var documentModeDebugEnabled = props.documentModeDebugEnabled,
        documentModeData = props.documentModeData,
        gridSize = props.gridSize;

    if (!documentModeDebugEnabled) return null;

    var clusterReadingLines = documentModeData.getIn(['details', 'readingData']);
    var clustersData = documentModeData.getIn(['details', 'children']);
    var elementOrder = documentModeData.get('order');

    return _react2.default.createElement(
        'div',
        { className: 'DocumentModeCanvasDebugger' },
        clustersData.map(function (clusterData, index) {
            return _react2.default.createElement(_DocumentModeCanvasClusterDebugger2.default, {
                key: index, gridSize: gridSize, clusterIndex: index + 1,
                clusterData: clusterData, elementOrder: elementOrder });
        }),
        clusterReadingLines.map(function (readingLine, index) {
            return _react2.default.createElement(_DocumentModeCanvasReadingLineDebugger2.default, _extends({
                className: 'cluster',
                key: index,
                gridSize: gridSize,
                order: index + 1
            }, readingLine.toJS()));
        })
    );
};

DocumentModeCanvasDebugger.propTypes = {
    documentModeDebugEnabled: _propTypes2.default.bool,
    documentModeData: _propTypes2.default.object,
    gridSize: _propTypes2.default.number.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DocumentModeCanvasDebugger);


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/documentMode/DocumentModeCanvasDebugger.js
// module id = 1942
// module chunks = 0